(function () {
  var MODEL_PREFIXES = [
    'iphone-', 'ipad-', 'galaxy-', 'redmi-', 'xiaomi-', 'huawei-', 'oppo-', 'realme-',
    'poco-', 'motorola-', 'apple-watch-', 'galaxy-watch-', 'mi-band-', 'redmi-watch-',
    'huawei-watch-', 'amazfit-', 'garmin-', 'fitbit-', 'honor-watch-',
  ];

  var STRICT_MODEL_COLLECTIONS = ['col-capas', 'col-peliculas', 'col-relogios'];

  var CAMERA_TAGS = ['peliculas-lente-camera', 'sub-camera', 'camera'];

  function modelTags(tags) {
    return (tags || []).filter(function (t) {
      var tag = String(t).toLowerCase();
      return MODEL_PREFIXES.some(function (p) {
        return tag.indexOf(p) === 0;
      });
    }).map(function (t) {
      return String(t).toLowerCase();
    });
  }

  /** Prefer the most specific model tag (longest). Never infer from title. */
  function primaryModelTag(tags) {
    var models = modelTags(tags);
    if (!models.length) return '';
    return models.reduce(function (best, m) {
      return m.length > best.length ? m : best;
    }, models[0]);
  }

  function requiresStrictModel(tags) {
    return STRICT_MODEL_COLLECTIONS.some(function (col) {
      return (tags || []).indexOf(col) !== -1;
    });
  }

  function itemModelTags(item) {
    if (item.models && item.models.length) {
      return item.models.map(function (m) {
        return String(m).toLowerCase();
      });
    }
    return modelTags(item.tags || []);
  }

  /** Exact model equality only — never prefix (iphone-15 ≠ iphone-15-pro). */
  function sharesExactModel(primaryModel, item) {
    if (!primaryModel) return false;
    var targetModels = itemModelTags(item);
    return targetModels.indexOf(primaryModel) !== -1;
  }

  function hasTag(item, tag) {
    return (item.tags || []).indexOf(tag) !== -1;
  }

  function isCameraProtection(item) {
    return CAMERA_TAGS.some(function (t) {
      return hasTag(item, t);
    });
  }

  /** col-peliculas source: capas → camera → other películas. */
  function peliculaPriority(item) {
    if (hasTag(item, 'col-capas')) return 0;
    if (isCameraProtection(item)) return 1;
    if (hasTag(item, 'col-peliculas')) return 2;
    return 3;
  }

  function titleMatches(title, needles) {
    if (!needles || !needles.length) return true;
    var t = String(title || '').toLowerCase();
    return needles.some(function (n) {
      return t.indexOf(String(n).toLowerCase()) !== -1;
    });
  }

  function ruleMatches(rule, productTags, productTitle) {
    var tags = productTags || [];
    var any = rule.when_any_tags || [];
    var all = rule.when_all_tags || [];
    if (any.length && !any.some(function (t) { return tags.indexOf(t) !== -1; })) return false;
    if (all.length && !all.every(function (t) { return tags.indexOf(t) !== -1; })) return false;
    if (!titleMatches(productTitle, rule.when_title_any)) return false;
    return true;
  }

  function formatPrice(value) {
    try {
      return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(value);
    } catch (e) {
      return value + ' €';
    }
  }

  function shopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function mapShopifyProduct(p) {
    var img = '';
    if (p.featured_image) {
      img = typeof p.featured_image === 'string'
        ? p.featured_image
        : (p.featured_image.url || p.featured_image.src || '');
    } else if (p.images && p.images.length) {
      var first = p.images[0];
      img = typeof first === 'string' ? first : (first.src || first.url || '');
    }
    var cents = p.price_min != null ? p.price_min : p.price;
    return {
      handle: p.handle,
      title: p.title,
      url: p.url || '/products/' + p.handle,
      image: img || '',
      price: (cents || 0) / 100,
      available: p.available !== false,
    };
  }

  function fetchLiveProduct(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch(shopifyRoot() + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed');
        return r.json();
      })
      .then(function (p) {
        var mapped = mapShopifyProduct(p);
        if (!mapped.available || !(mapped.price > 0)) return null;
        return mapped;
      })
      .catch(function () {
        return null;
      });
  }

  function hydrateLive(candidates, limit) {
    var max = Math.max(limit * 2, limit);
    var slice = candidates.slice(0, max);
    return Promise.all(slice.map(function (c) {
      return fetchLiveProduct(c.handle).then(function (live) {
        if (!live) return null;
        return live;
      });
    })).then(function (results) {
      var out = [];
      results.forEach(function (item) {
        if (item && out.length < limit) out.push(item);
      });
      return out;
    });
  }

  function renderCard(item) {
    var a = document.createElement('a');
    a.className = 'tek-crosssell__card';
    a.href = item.url;
    if (item.image) {
      var img = document.createElement('img');
      img.className = 'tek-crosssell__img';
      img.loading = 'lazy';
      img.alt = item.title || '';
      img.src = item.image;
      a.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'tek-crosssell__img tek-crosssell__img--placeholder';
      ph.setAttribute('aria-hidden', 'true');
      ph.textContent = 'Imagem em atualização';
      a.appendChild(ph);
    }
    var body = document.createElement('div');
    body.className = 'tek-crosssell__body';
    var t = document.createElement('p');
    t.className = 'tek-crosssell__title';
    t.textContent = item.title || '';
    var p = document.createElement('p');
    p.className = 'tek-crosssell__price';
    p.textContent = formatPrice(item.price || 0);
    body.appendChild(t);
    body.appendChild(p);
    a.appendChild(body);
    return a;
  }

  function renderItems(root, headingText, items) {
    if (!items.length) {
      root.hidden = true;
      return;
    }
    var heading = root.querySelector('.tek-crosssell__heading');
    if (heading) heading.textContent = headingText || 'Também te pode interessar';
    var grid = root.querySelector('.tek-crosssell__grid');
    if (!grid) return;
    grid.innerHTML = '';
    items.forEach(function (item) {
      grid.appendChild(renderCard(item));
    });
    root.hidden = false;
  }

  function fetchRecommendations(productId, intent) {
    if (!productId) return Promise.resolve([]);
    var url =
      shopifyRoot() +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&limit=8&intent=' +
      encodeURIComponent(intent || 'related');
    return fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('recommendations failed');
        return r.json();
      })
      .then(function (data) {
        return (data.products || []).map(mapShopifyProduct).filter(function (p) {
          return p.available !== false && p.price > 0;
        });
      })
      .catch(function () {
        return [];
      });
  }

  function shouldMatchModel(rule, productTags) {
    if (rule.match_model_tag) return true;
    return requiresStrictModel(productTags);
  }

  function itemsFromRules(rulesDoc, catalogDoc, productTags, productTitle, productHandle, primaryModel) {
    var rules = rulesDoc.rules || [];
    var catalog = catalogDoc.rules || {};
    var matched = rules.filter(function (rule) {
      return ruleMatches(rule, productTags, productTitle);
    });
    if (!matched.length) return { items: [], heading: '', needsModel: false };

    var anyNeedsModel = matched.some(function (rule) {
      return shouldMatchModel(rule, productTags);
    });

    // Model-based rules require a safe primary model tag — never guess from title.
    if (anyNeedsModel && !primaryModel) {
      var nonModel = matched.filter(function (rule) {
        return !shouldMatchModel(rule, productTags);
      });
      if (!nonModel.length) {
        return { items: [], heading: '', needsModel: true };
      }
      matched = nonModel;
      anyNeedsModel = false;
    }

    var items = [];
    var seen = {};
    matched.forEach(function (rule) {
      var pool = catalog[rule.id] || [];
      var matchModel = shouldMatchModel(rule, productTags);
      pool.forEach(function (item) {
        if (item.handle === productHandle || seen[item.handle]) return;
        if (matchModel && !sharesExactModel(primaryModel, item)) return;
        seen[item.handle] = true;
        items.push(item);
      });
    });

    var isPeliculaSource = (productTags || []).indexOf('col-peliculas') !== -1;
    if (isPeliculaSource && primaryModel) {
      items.sort(function (a, b) {
        return peliculaPriority(a) - peliculaPriority(b);
      });
    }

    var heading = matched[0].label || 'Combina bem com';
    if (isPeliculaSource && items.length) {
      var top = peliculaPriority(items[0]);
      if (top === 0) heading = 'Capas para o teu modelo';
      else if (top === 1) heading = 'Completa a proteção';
      else heading = 'Também para o teu modelo';
    }

    return {
      items: items,
      heading: heading,
      needsModel: anyNeedsModel,
    };
  }

  function init(root) {
    var ctxEl = document.getElementById('tek-crosssell-context');
    if (!ctxEl || !root) return;

    var ctx;
    try {
      ctx = JSON.parse(ctxEl.textContent || '{}');
    } catch (e) {
      return;
    }

    var productTags = (ctx.product_tags || []).map(function (t) {
      return String(t).toLowerCase();
    });
    var productTitle = ctx.product_title || '';
    var productHandle = ctx.product_handle || '';
    var productId = ctx.product_id;
    var primaryModel = primaryModelTag(productTags);
    var strictModel = requiresStrictModel(productTags);
    var isPeliculaSource = productTags.indexOf('col-peliculas') !== -1;
    var limit = parseInt(root.dataset.limit || '8', 10);
    if (isPeliculaSource) limit = Math.min(limit, 6);

    Promise.all([
      fetch(root.dataset.rulesUrl).then(function (r) { return r.json(); }),
      fetch(root.dataset.catalogUrl).then(function (r) { return r.json(); }),
    ])
      .then(function (res) {
        var picked = itemsFromRules(
          res[0],
          res[1],
          productTags,
          productTitle,
          productHandle,
          primaryModel
        );
        var candidates = picked.items;
        if (isPeliculaSource) {
          candidates = candidates.slice(0, Math.max(limit * 3, 12));
        } else {
          candidates = candidates.slice(0, Math.max(limit * 2, 8));
        }

        if (candidates.length) {
          return hydrateLive(candidates, limit).then(function (liveItems) {
            if (liveItems.length) {
              renderItems(root, picked.heading, liveItems);
              return;
            }
            if (strictModel || picked.needsModel) {
              root.hidden = true;
              return;
            }
            return fallbackRecommendations(root, productId, limit);
          });
        }

        if (strictModel || picked.needsModel) {
          root.hidden = true;
          return;
        }
        return fallbackRecommendations(root, productId, limit);
      })
      .catch(function () {
        if (strictModel) {
          root.hidden = true;
          return;
        }
        fallbackRecommendations(root, productId, limit);
      });
  }

  function fallbackRecommendations(root, productId, limit) {
    return fetchRecommendations(productId, 'complementary').then(function (fallback) {
      if (!fallback.length) {
        return fetchRecommendations(productId, 'related');
      }
      return fallback;
    }).then(function (fallback) {
      var ok = (fallback || []).filter(function (p) {
        return p.price > 0;
      }).slice(0, limit);
      renderItems(root, 'Também te pode interessar', ok);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tek-crosssell]').forEach(init);
  });
})();
